import {
  isArray,
  flatMap,
  map,
  keys,
  isPlainObject,
  concat,
  get,
} from 'lodash';
import { CsvObject } from '../model/validation';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

export const formatNgbDate = (ngbDate: NgbDate): string => {
  const { year, month, day } = ngbDate;
  return `${year}-${month < 10 ? '0' + month : month}-${
    day < 10 ? '0' + day : day
  }`;
};

export const processDataForCsvDoc = (data: any) => {
  if (!Array.isArray(data)) data = [data];
  let allCsvRows: CsvObject[] = [];
  data.forEach((validationResult) => {
    let csvRows: CsvObject[] = [];
    const payloadId = validationResult['id'];
    const payloadDate = validationResult['createdDate'];
    const OverallStatus = validationResult['status'];
    const mnemonic = validationResult['ref'] || validationResult['uniqueId'];
    // const validationReference =  validationResult['ref']
    validationResult.validationResults?.forEach((result) => {
      let parsedCriteria = result['selection_criteria']
        ? JSON.parse(result['selection_criteria'])
        : '';
      let criteria = parsedCriteria?.criteria;
      buildRow(result, csvRows, {
        'Payload ID': payloadId,
        'Payload Reference': mnemonic,
        // 'Multi-complex Mnemonic': mnemonic,
        'Created Date': payloadDate,
        'Overall Status': OverallStatus,
        'Selection Criteria': criteria ? criteria.join('/') : 'n/a',
      });
    });
    allCsvRows = allCsvRows.concat(csvRows);
    allCsvRows.push(emptyRow());
  });
  return allCsvRows;
};

export const buildRow = (result, csvRows, csvRow) => {
  let newRow;
  const currentRuleId = result.ruleId;

  let x = result['selection_criteria']
    ? JSON.parse(result['selection_criteria'])
    : '';
  let z = x?.criteria;
  if (result['ruleResults']) {
    const mnemonicColName = getColName(currentRuleId, 'Mnemonic');
    const descriptionColName = getColName(currentRuleId, 'Description');
    const statusColName = getColName(currentRuleId, 'Status');

    csvRow[`${mnemonicColName}`] = result['mnemonic'] || result['ruleId'];
    csvRow[`${statusColName}`] = result['status'] || 'n/a';

    csvRow[`${descriptionColName}`] = result['description'] || 'n/a';
    result['ruleResults'].forEach((r) => buildRow(r, csvRows, csvRow));
  } else {
    newRow = { ...csvRow };

    newRow[`Simple Mnemonic`] = result['ruleId'];
    newRow[`Path`] = result['jmespath'];
    newRow[`Calculation`] = result['calculation'];
    newRow[`Value`] = result['payloadValue'];
    newRow[`Status`] = result['status'];
    const keys = Object.keys(newRow);
    if (!keys.includes('Multi-complex Mnemonic')) {
      const emptyMultiComplexRow = {
        'Payload ID': '',
        'Multi-complex Mnemonic': '',
        'Multi-complex Description': '',
        'Created Date': '',
        'Overall Status': '',
        'Selection Criteria': '',
      };
      Object.assign(emptyMultiComplexRow, newRow);
      checkPayloadId(csvRows, emptyMultiComplexRow as CsvObject);
      csvRows.push(emptyMultiComplexRow);
    }
    checkPayloadId(csvRows, newRow);
    csvRows.push(newRow as any);
  }
};

export const getColName = (currentRuleId: string, col: string) => {
  if (currentRuleId.toLowerCase().includes('mcx')) {
    return `Multi-complex ${col}`;
  } else if (currentRuleId.toLowerCase().includes('cx')) {
    return `Complex ${col}`;
  } else {
    return `Combo ${col}`;
  }
};

export const checkPayloadId = (
  csvObjectsArray: CsvObject[],
  currentCsvObject: CsvObject
): void => {
  if (csvObjectsArray.length > 0) {
    const firstCsvObj = csvObjectsArray[0];
  //   if (currentCsvObject['Payload ID'] === firstCsvObj['Payload ID'])
  //     currentCsvObject['Payload ID'] = '';
  //   if (currentCsvObject['Overall Status'] === firstCsvObj['Overall Status'])
  //     currentCsvObject['Overall Status'] = '';
  //   if (
  //     currentCsvObject['Multi-complex Mnemonic'] ===
  //     firstCsvObj['Multi-complex Mnemonic']
  //   )
  //     currentCsvObject['Multi-complex Mnemonic'] = '';
  }
};

export const emptyRow = () => {
  return {
    'Payload ID': '',
    'Multi-complex Description': '',
    'Multi-complex Mnemonic': '',

    'Created Date': '',
    'Complex Mnemonic': '',
    'Complex Status': '',
    'Complex Description': '',
    'Combo Mnemonic': '',
    'Combo Status': '',
    'Combo Description': '',
    'Simple Mnemonic': '',
    'Path': '',
    'Calculation': '',
    'Value': '',
    'Status': '',

    'Overall Status': '',
    'Selection Criteria': '',
  } as CsvObject;
};
